<template>
  <div class="embed-media-placeholder" :style="cssVars">
    <template v-if="source === 'yt' && id">
      <iframe
        :src="`https://www.youtube-nocookie.com/embed/${id}`"
        title="YouTube video player"
        loading="lazy"
        referrerpolicy="strict-origin-when-cross-origin"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      />
    </template>
  </div>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    aspectRatio: {
      type: String,
      default: null
    },
    aspectRatioMobile: {
      type: String,
      default: null
    }
  },
  computed: {
    cssVars () {
      return {
        '--aspect-ratio': this.aspectRatio && this.aspectRatio !== 'original' ? this.aspectRatio : '16/9',
        '--aspect-ratio-mobile': this.aspectRatioMobile && this.aspectRatioMobile !== 'original' ? this.aspectRatioMobile : '16/9'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.embed-media-placeholder {
  width: 100%;
  background-color: #eeeeee;
  aspect-ratio: var(--aspect-ratio);
  border-radius: 20px;
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile);
  }
  :deep(iframe) {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 20px;
  }
}
</style>
